import { useEffect, useState } from 'react';
import './NotificationStyles.css';
import Conect from '../../../../Api/Conect';
import NotificationsAlert from '../../../services/NotificationsAlert';

const typeIdMapping = [
    { id: 1, description: "IGNICAOLIGADA", desc: "IG_ON", name: "Ignição Ligada" },
    { id: 2, description: "IGNICAODESLIGADA",desc: "IG_OFF", name: "Ignição Desligada" },
    { id: 3, description: "LIMITEVELOCIDADE",desc: "VEL_EXCESS", name: "Limite Velocidade" },
    { id: 4, description: "BATERIABAIXA",desc: "BAT_LOW", name: "Bateria Baixa" },
    { id: 5, description: "BATERIADESCONECTADA",desc: "BAT_OFF", name: "Bateria Desconectada" },
    { id: 6, description: "TROCADEOLEO",desc: "OIL_CHANGE", name: "Troca de Oleo" },
    { id: 7, description: "MANUTENCAO",desc: "MAINTENCE", name: "Manutenção" }
];

const ModalEditNotification = ({ isOpen, onClose, data, idVehicle, id_user }) => {

    const [notifications, setData] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editedData, setEditedData] = useState({});
    const [isCreating, setIsCreating] = useState(false);

    let vehicleId = idVehicle !== undefined && idVehicle

    useEffect(() => {
        if (data) setData(data);
    }, [data]);

    const fetchNotifications = async () => {
        const response = await Conect.post(`/Z2V0Tm90aWZpY2F0aW9uc1ZlaGljbGVXaGVyZUlk`, {
            idVehicle: vehicleId
        });

        if (response.data.erro === true) {
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        else {
            // eslint-disable-next-line
            setData(response.data.notification);
        }
    };

    const handleStartEdit = (notification) => {
        setEditingId(notification.id);
        setEditedData({ ...notification });
    };

    const handleChange = (field, value) => {
        setEditedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const isModified = (original, edited) => {
        return (
            original.email !== edited.email ||
            original.limit !== edited.limit ||
            original.app !== edited.app ||
            original.telegram !== edited.telegram ||
            original.status !== edited.status ||
            original.type_id !== edited.type_id
        );
    };

    const handleSave = async () => {
        try {
            let response;

            const type = typeIdMapping.find(t => t.id === editedData.type_id);
            const desc = type?.description || null;

            if (editingId === "new") {
                response = await Conect.post(`/crianotificationveiculo`, {
                    ...editedData,
                    vehicle_id: idVehicle,
                    user_id: Number(id_user),
                    description: desc
                });
            } else {
                response = await Conect.put(`/editnotificationveiculo`, editedData);
            }

            if (response?.data?.erro) {
                NotificationsAlert("warning", "Atenção", response.data.msg || "Erro ao salvar");
                return;
            }

            NotificationsAlert(
                "success",
                "Sucesso",
                editingId === "new"
                    ? "Notificação criada com sucesso!"
                    : "Notificação atualizada!"
            );

            setEditingId(null);
            setIsCreating(false);

            await fetchNotifications();

        } catch (err) {
            console.error("Erro ao salvar:", err);

            NotificationsAlert(
                "error",
                "Erro",
                "Falha ao comunicar com o servidor"
            );
        }
    };

    const handleCreate = () => {
        setIsCreating(true);
        setEditingId("new");

        setEditedData({
            type_id: 1,
            app: 1,
            email: 0,
            telegram: 0,
            status: 1
        });
    };

    const handleDelete = async (notification) => {
        if (!window.confirm("Deseja remover essa notificação?")) return;

        const response = await Conect.delete(`/deletenotificationveiculo`, {
            data: { id: notification.id }
        });

        if (!response.data.erro) {
            await fetchNotifications();
        }
    };

    const handleCancel = () => {
        setEditingId(null);
        setIsCreating(false);
    };

    const handleClearFields = () => {
        setEditedData({
            type_id: 1,
            email: 0,
            telegram: 0,
            status: 1,
            hodometer: 0
        });
    };

    return (
        isOpen && (
            <div className="modal-overlay-notifications">
                <div className="modal-content-notifications">
                    <div className="modal-header">
                        <button
                            className="action-btn"
                            onClick={handleCreate}
                            disabled={isCreating}
                        >
                            + Nova Notificação
                        </button>

                        <h2>Notificações</h2>

                        <button
                            className='btn-close-notifications'
                            onClick={() => {
                                onClose();
                                setEditingId(null);
                            }}
                        >
                            Fechar
                        </button>
                    </div>

                    <table className='task-table-notifications'>
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th>Hodometro</th>
                                <th>Velocidade</th>
                                <th>Aplicativo</th>
                                <th>Email</th>
                                <th>Telegram</th>
                                <th>Notificação</th>
                                <th>Ação</th>
                                <th>Ação</th>
                                <th>Ação</th>
                            </tr>
                        </thead>

                        <tbody>
                            {Array.isArray(notifications) && notifications.map((notification) => {

                                const type = typeIdMapping.find(t => t.id === notification.type_id);
                                const isEditing = editingId === notification.id;

                                return (
                                    <tr key={notification.id}>

                                        {/* TIPO */}
                                        <td>
                                            {isEditing ? (
                                                <select
                                                    value={editedData.type_id}
                                                    onChange={(e) => handleChange("type_id", Number(e.target.value))}
                                                >
                                                    {typeIdMapping.map(t => (
                                                        <option key={t.id} value={t.id}>{t.name}</option>
                                                    ))}
                                                </select>
                                            ) : (
                                                type?.name || "Desconhecido"
                                            )}
                                        </td>

                                        {/* Hodometro */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    value={editedData.hodometer || ""}
                                                    onChange={(e) => handleChange("hodometer", Number(e.target.value))}
                                                    placeholder="Km"
                                                />
                                            ) : (
                                                notification.hodometer || "-"
                                            )}
                                        </td>

                                        {/* Velocidade */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    value={editedData.limit || ""}
                                                    onChange={(e) => handleChange("limit", Number(e.target.value))}
                                                    placeholder="KM/h"
                                                />
                                            ) : (
                                                notification.limit || "-"
                                            )}
                                        </td>

                                        {/* App */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="checkbox"
                                                    checked={editedData.app}
                                                    onChange={(e) => handleChange("app", e.target.checked ? 1 : 0)}
                                                />
                                            ) : (
                                                notification.app ? "Ativo" : "Inativo"
                                            )}
                                        </td>
                                        {/* EMAIL */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="checkbox"
                                                    checked={editedData.email}
                                                    onChange={(e) => handleChange("email", e.target.checked ? 1 : 0)}
                                                />
                                            ) : (
                                                notification.email ? "Ativo" : "Inativo"
                                            )}
                                        </td>

                                        {/* TELEGRAM */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="checkbox"
                                                    checked={editedData.telegram}
                                                    onChange={(e) => handleChange("telegram", e.target.checked ? 1 : 0)}
                                                />
                                            ) : (
                                                notification.telegram ? "Ativo" : "Inativo"
                                            )}
                                        </td>

                                        {/* STATUS */}
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="checkbox"
                                                    checked={editedData.status}
                                                    onChange={(e) => handleChange("status", e.target.checked ? 1 : 0)}
                                                />
                                            ) : (
                                                <span className={notification.status ? "ativo" : "inativo"}>
                                                    {notification.status ? "Ativo" : "Inativo"}
                                                </span>
                                            )}
                                        </td>


                                        {/* TOGGLE STATUS */}
                                        <td>
                                            {isEditing && (
                                                <>
                                                    <button
                                                        className="action-btn"
                                                        onClick={() => setEditingId(null)}
                                                    >
                                                        ❌
                                                    </button>
                                                </>
                                            )}
                                        </td>
                                        {/* EDITAR / SALVAR */}
                                        <td>
                                            {isEditing ? (
                                                <>
                                                    <button
                                                        className="action-btn"
                                                        onClick={handleSave}
                                                        disabled={!isModified(notification, editedData)}
                                                    >
                                                        💾
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="action-btn"
                                                    onClick={() => handleStartEdit(notification)}
                                                >
                                                    ✏️
                                                </button>
                                            )}
                                        </td>

                                        {/* DELETE */}
                                        <td>
                                            <button
                                                className="action-btn"
                                                onClick={() => handleDelete(notification)}
                                            >
                                                🗑️
                                            </button>
                                        </td>


                                    </tr>
                                );
                            })}
                            {isCreating && (
                                <tr>

                                    {/* TIPO */}
                                    <td>
                                        <select
                                            value={editedData.type_id}
                                            onChange={(e) => handleChange("type_id", Number(e.target.value))}
                                        >
                                            {typeIdMapping.map(t => (
                                                <option key={t.id} value={t.id}>{t.name}</option>
                                            ))}
                                        </select>
                                    </td>

                                    <td>
                                        <input
                                            type="number"
                                            value={editedData.hodometer || ""}
                                            onChange={(e) => handleChange("hodometer", Number(e.target.value))}
                                            placeholder="Km"
                                        />
                                    </td>

                                    {/* VELOCIDADE */}
                                    <td>
                                        <input
                                            type="number"
                                            value={editedData.limit || ""}
                                            onChange={(e) => handleChange("limit", Number(e.target.value))}
                                            placeholder="Km/h"
                                        />
                                    </td>

                                    {/* App */}
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={editedData.app}
                                            onChange={(e) => handleChange("app", e.target.checked ? 1 : 0)}
                                        />
                                    </td>

                                    {/* EMAIL */}
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={editedData.email}
                                            onChange={(e) => handleChange("email", e.target.checked ? 1 : 0)}
                                        />
                                    </td>

                                    {/* TELEGRAM */}
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={editedData.telegram}
                                            onChange={(e) => handleChange("telegram", e.target.checked ? 1 : 0)}
                                        />
                                    </td>

                                    {/* STATUS */}
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={editedData.status}
                                            onChange={(e) => handleChange("status", e.target.checked ? 1 : 0)}
                                        />
                                    </td>

                                    {/* SALVAR */}
                                    <td>
                                        <button className="action-btn" onClick={handleSave}>
                                            💾
                                        </button>
                                    </td>
                                    <td>
                                        <button className="action-btn" onClick={handleClearFields}>
                                            🔄
                                        </button>
                                    </td>
                                    <td>

                                        <button className="action-btn" onClick={handleCancel}>
                                            ❌
                                        </button>
                                    </td>

                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    );
};

export default ModalEditNotification;